import type { Options } from 'ky';
import type { IAuthSDK } from '../base-client/AuthSDK';
import { MagnitIdConfig } from './MagnitIdConfig';
import { MMBaseClient } from '../base-client/MMBaseClient';
import { KasperskyEvent } from '~/shared/helpers/KasperskyEvent';

// Клиент для magnit-id
export class MagnitIdClient extends MMBaseClient {
  aud: string = '';
  kasperskyDeviceTag: string | null = null;

  constructor(
    { authSDK }: { authSDK?: IAuthSDK } = {},
  ) {
    const config = new MagnitIdConfig();
    const baseUrl = config.getBaseUrl();
    super(baseUrl, authSDK);

    this.aud = config.aud;

    this.kyInstance = this.kyInstance.extend((options: Options) => ({
      headers: {
        ...options.headers,
        ...config.DEFAULT_HEADERS,
      },
    }));
  }

  async getKasperskyDeviceTag(): Promise<string> {
    if (this.kasperskyDeviceTag) {
      return this.kasperskyDeviceTag;
    }

    this.kasperskyDeviceTag = await KasperskyEvent.getKasperskyDeviceTag();
    return this.kasperskyDeviceTag || '';
  }
}
